'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "sidebarBackgroundColor", "sidebarComponent"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import omit from '../utils/underscore/omit';
import UIAbstractPageTemplate from './UIAbstractPageTemplate';
import { GYPSUM, SLINKY, TRANSPARENT } from 'HubStyleTokens/colors';
import { rgba } from '../core/Color';
import { GRID_BREAKPOINT_SMALL, GRID_BREAKPOINT_MEDIUM, NAV_BAR_HEIGHT } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
const BLUR_RADIUS = '3px';
const Sidebar = styled.div.withConfig({
  displayName: "UISidebarPage__Sidebar",
  componentId: "sc-1dsx3f7-0"
})(["padding-top:20px;padding-right:32px;padding-left:32px;overflow-y:auto;"]);
const Main = styled.div.withConfig({
  displayName: "UISidebarPage__Main",
  componentId: "sc-1dsx3f7-1"
})(["padding:20px 16px;@media only screen and (max-width:", "){padding-right:8px;padding-left:8px;}@media only screen and (max-width:", "){padding-right:0;padding-left:0;}"], GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_SMALL);
function UISidebarPage(props) {
  const {
      children,
      sidebarBackgroundColor,
      sidebarComponent
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const sidebarContent = /*#__PURE__*/_jsx(Sidebar, {
    children: sidebarComponent
  });
  const mainContent = /*#__PURE__*/_jsx(Main, {
    children: children
  });
  const sidebarStyle = {
    backgroundColor: sidebarBackgroundColor,
    minHeight: `calc(100vh - ${NAV_BAR_HEIGHT}})`
  };
  if (sidebarBackgroundColor !== TRANSPARENT) {
    // Add vertical divider between sidebar and main content
    Object.assign(sidebarStyle, {
      boxShadow: `1px 0 ${BLUR_RADIUS} 0 ${rgba(SLINKY, 0.25)}`,
      marginRight: BLUR_RADIUS,
      [`@media only screen and (max-width: ${GRID_BREAKPOINT_SMALL})`]: {
        boxShadow: 'none',
        marginRight: 0
      }
    });
  }
  return /*#__PURE__*/_jsx(UIAbstractPageTemplate, Object.assign({
    contentAreaFlush: true,
    sidebarAreaFlush: true,
    sidebarComponent: sidebarContent,
    pageLayout: "full-width",
    stickySidebar: true,
    sidebarStyle: sidebarStyle
  }, rest, {
    children: mainContent
  }));
}
UISidebarPage.propTypes = Object.assign({}, omit(UIAbstractPageTemplate.propTypes, ['contentAreaFlush', 'mainClassName', 'pageLayout', 'sidebarAreaFlush', 'stickySidebar']), {
  children: PropTypes.node,
  sidebarBackgroundColor: PropTypes.string
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UISidebarPage.defaultProps = Object.assign({}, omit(UIAbstractPageTemplate.defaultProps, ['contentAreaFlush', 'headerComponent', 'pageLayout', 'sidebarAreaFlush', 'stickySidebar']), {
  sidebarBackgroundColor: GYPSUM,
  headerComponent: null
});
UISidebarPage.displayName = 'UISidebarPage';
export default UISidebarPage;